import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatMenuItem} from '@angular/material/menu';

@Component({
  selector: 'mx-menu-item',
  template: `
    <button mat-menu-item type="button" [disabled]="!enabled" class="mx-button-component">
      {{ label }}
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatMenuItem]
})
export class MenuItemComponent {
  @Input({required: true}) public label: string;
  @Input() public enabled: boolean = true;
}
